export enum MMB_ACTIONS {
    SAVE = 'save',
    EXPRESS_INTEREST = 'express_interest'
}